<template>
  <div class="xcard">
    <template>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :loading="loading"
        hide-default-footer
        disable-pagination
        sort-by="calories"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Unidades de negocio </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </template>

    <UnidadesAM ref="unidadesam" v-on:onnewreg="getunidades" />
    <UnidadesDEL ref="unidadesdel" />
  </div>
</template>

<script>
  import UnidadesAM from '@/views/unidades/Unidadesam.vue';
  import UnidadesDEL from '@/views/unidades/Unidadesdel.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: false,
          value: 'nombre',
        },
        { text: 'Codigo', value: 'codigo' },
        { text: 'Descripcion', value: 'descripcion' },
        //{ text: 'Correo', value: 'email' },
        // { text: 'Sitio web', value: 'sitio_web', sortable: false },
        { text: '', value: 'actions', sortable: false },
        //{ text: 'Actions', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      loading: false,
    }),

    components: { UnidadesAM, UnidadesDEL },

    created() {
      this.initialize();
      this.getunidades();
    },

    methods: {
      initialize() {},

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.$refs.unidadesam.openmodal(item);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.$refs.unidadesdel.openmodal();
      },
      async getunidades() {
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/unidadnegocio`;
        vue.desserts = [];
        vue.loading = true;
        await xaxios
          .get(url)
          .then(({ data }) => {
            window.console.log(data, vue);
            vue.desserts = data;
            vue.loading = false;
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading = false;
          });
      },
    },
    mounted() {},
  };
</script>
